module.exports = __webpack_public_path__ + "static/media/play-icon.2e5f530a.svg";